import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  NgZone
} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {ListingService} from "../../services/listing.service";
import {Facet, SelectedFacet} from "../../model/ListingModel";
import {Subscription} from "rxjs";
import {BreakpointsService} from "../../services/breakpoints.service";
import {SelectedFacetWithLabel, FramesSizeFilter} from "../../model/enums/Facets.enum";
declare const window: any;

@ComponentAsElement('v-listing-facets-element')
@Component({
  selector: 'v-listing-facets',
  templateUrl: './listing-facets.component.html'
})
export class ListingFacetsComponent implements OnInit, OnDestroy {
  @Input() themePath: string;
  public facets: Facet[];
  public selected: SelectedFacet[];
  private subscriptions: Subscription = new Subscription;
  public breakpoint$;
  public selectedFacetWithLabel = SelectedFacetWithLabel;
  public showFacets = false;
  public selectedMobile = '';
  public framesSizes = {};
  public selectedCount = 0;
  public processing = false;
  public selectedSizes = {};

  constructor(
    private listingService: ListingService,
    private breakpointsService: BreakpointsService,
    private renderer2: Renderer2,
    private ngZone: NgZone
  ) {
    window['angularListingFacetsComponentReference'] = {
      component: this,
      zone: this.ngZone,
      runFilterProducts: (_bResetSearch = true) => this.filterProducts(_bResetSearch)
    };
  }

  ngOnInit() {
    this.subscriptions.add(this.listingService.facetsList.subscribe(_facets => {
      this.selectedCount = 0;
      this.setFacets(_facets);
      this.processing = false;
    }));
    this.subscriptions.add(this.listingService.selectedList.subscribe(_selected => this.setSelected(_selected)));
    this.breakpoint$ = this.breakpointsService.breakpoint$;
    this.breakpoint$.subscribe(breakpoint =>  {
      if(breakpoint === 'desktop') {
       this.closeFacetsMobile();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  setFacets(_facets) {
    const facets = _facets;
    const visibleFacets = [];

    facets.forEach(facet => {
      switch (facet.code) {
        case FramesSizeFilter.lensWidth: {
          this.framesSizes[FramesSizeFilter.lensWidth] = facet;
          break;
        }
        case FramesSizeFilter.framesSize: {
          this.framesSizes[FramesSizeFilter.framesSize] = facet;
          break;
        }
        case FramesSizeFilter.noseSize: {
          this.framesSizes[FramesSizeFilter.noseSize] = facet;
          break;
        }
        default: {
          visibleFacets.push(facet)
        }
      }
    });

    this.facets = [...visibleFacets];
  }

  setSelected(_selected) {
    const facetsPositions = [...Object.keys(this.framesSizes), ...this.facets.map(facet => facet.code)];
    const selectedSorted = facetsPositions.length > 3 ?
      _selected.sort((a, b) => facetsPositions.indexOf(a.facetCode) - facetsPositions.indexOf(b.facetCode))
      : _selected.sort((a, b) => a.facetCode.localeCompare(b.facetCode));

    this.selectedSizes = {};
    this.selected = [];
    if(selectedSorted.length) {
      selectedSorted.forEach(facet => {
        if(facet.facetCode === this.selectedFacetWithLabel.lensWidth
          || facet.facetCode === this.selectedFacetWithLabel.noseSize || facet.facetCode === this.selectedFacetWithLabel.framesSize) {
          if(!this.selectedSizes[facet.facetCode]) this.selectedSizes[facet.facetCode] = [];
          this.selectedSizes[facet.facetCode].push(facet)
        }
      })
      this.selected = selectedSorted.filter(facet => facet.facetCode !== this.selectedFacetWithLabel.lensWidth
        && facet.facetCode !== this.selectedFacetWithLabel.noseSize && facet.facetCode !== this.selectedFacetWithLabel.framesSize);
      this.selectedCount = selectedSorted.length;
    }
  }

  filterProducts(_bResetSearch = true, closeOnMobile = true) {
    this.processing = true;
    this.listingService.filterProducts(_bResetSearch);
    if(closeOnMobile) this.closeFacetsMobile();
  }

  filterFromSizes(closeOnMobile = true) {
    this.processing = true;
    if(closeOnMobile) this.closeFacetsMobile();
  }

  resetFilters() {
    this.processing = true;
    this.listingService.resetFilters();
    this.closeFacetsMobile()
  }

  removeAndFilter(_keyName, _group, _facet) {
    const checked = true;
    const keyName = _keyName;
    const key = _group;
    const value = _facet;

    this.processing = true;
    this.listingService.toggleFacetToSelected({checked, keyName, key, value}, true);
  }

  showFacetsMobile(_type) {
    const type = _type;

    if(this.selectedMobile === type) {
      this.selectedMobile = ''
      this.showFacets = false;
    } else {
      this.selectedMobile = type;
      this.showFacets = true;
    }


    this.renderer2[this.showFacets ? 'addClass' : 'removeClass'](document.body, '--hide-scroll');
    this.renderer2[this.showFacets ? 'addClass' : 'removeClass'](document.body, '--white-bg');
    this.renderer2[this.showFacets ? 'addClass' : 'removeClass'](document.querySelector('.listingFacets'), '-visibleMobile');
    this.renderer2[this.selectedMobile === 'sort' ? 'addClass' : 'removeClass'](document.querySelector('.listingFacets_sort'), '-active');
  }

  closeFacetsMobile() {
    this.selectedMobile = '';
    this.showFacetsMobile('');
  }

  clickFacet(_closeOnMobile) {
    this.filterProducts(false, _closeOnMobile);
  }
}
